import React, { useState } from 'react';


const Percentage = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const content = [
        "Doctors and Patients can check their schedules, and it improves the quality of service by minimal waiting time and accessing the medical records electronically.",
        "KlinicQ application can be accessed through the cloud on any type of mobile device anywhere & anytime and on desktop at on-premises.",
        "KlinicQ flawlessly integrates with existing appointments with walk-in patients to eliminate the scheduling gaps when appointments are canceled or rescheduled.",
        "KlinicQ's appointment scheduling solutions where appointments that are updated automatically so that every patient arriving late will be automatically pushed back in the queue. Medical records can be accessed from any place & any time."
    ];

    const handleClick = (index) => {
        setActiveIndex(activeIndex === index ? null : index); // Toggle the active index
    };

    const getColor = (index) => {
        switch (index) {
            case 0: return 'lightblue'; // Color for 35%
            case 1: return 'lightblue'; // Color for 30%
            case 2: return 'lightblue'; // Color for 35%
            default: return 'transparent';
        }
    };

    return (
        <div className='company-section container-90'>
            <div className='row m-0'>
                <div className='col-lg-6 col-12 slide-right visible content-company'>
                    <h1>Why KlinicQ?</h1>
                    <div className='img-responsive'>
                        <img src={require("../../src/assets/images/website/profile3.png")} className='w70 h70 ml-5 mt-50 d-lg-none d-block' alt="Profile" />
                    </div>
                    <div className='percentage-container'>
                        <div className='percentage' onClick={() => handleClick(0)}>35%</div>
                        <div className='percentage' onClick={() => handleClick(1)}>30%</div>
                        <div className='percentage' onClick={() => handleClick(2)}>35%</div>
                    </div>
                    <div className='text-container' style={{ backgroundColor: getColor(activeIndex) }}>
                        {activeIndex !== null && (
                            <p>{content[activeIndex]}</p>
                        )}
                    </div>
                </div>
                <div className='col-lg-6 col-12 slide-left visible'>
                    <img src={require("../../src/assets/images/website/profile3.png")} className='ml-5 d-lg-block d-none' alt="Profile" />
                </div>
            </div>
        </div>
    );
};

export default Percentage;